// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"271":"5aabc338","300":"388e2bb5","362":"fd79685c","372":"654369f4","453":"7377565a","500":"2989631e","771":"2c9f40e7","798":"0c6cff27","827":"672adcaa"}[chunkId] + ".chunk.js";
};